export default "__VITE_ASSET__BU3RBFIy__"